import countdown from "../countdown"
import upsell from "../upsell"

export default (getView) => (nextStepPath, timeoutSeconds) => ({
  ...getView(nextStepPath),
  ...countdown(timeoutSeconds),
  ...upsell("premium"),

  statusToTrack: "VISIT_CHECKOUT",

  onInit() {
    this.initCountdown()
    this.initUpsell()
  },
})
